<template>
  <div>
    <div v-if="loaded">
      <div v-if="windowWidth <= 768 && enterprise">
        <v-bottom-navigation
          grow
          v-model="bottomNav"
        >
          <router-link v-for="button in firstRowBtns" tag="v-btn" :key="button.name" :to="{ name: buildRoute(button.route) }">
            <span>{{ button.title }}</span>
            <v-icon>{{ button.icon }}</v-icon>
          </router-link>
        </v-bottom-navigation>
        <v-bottom-navigation
          grow
          v-model="bottomNav2"
        >
          <router-link v-for="button in secondRowBtns" tag="v-btn" :key="button.name" :to="{ name: buildRoute(button.route) }">
            <span>{{ button.title }}</span>
            <v-icon>{{ button.icon }}</v-icon>
          </router-link>
        </v-bottom-navigation>
      </div>
      <div v-else-if="windowWidth >= 768 && enterprise">
        <v-bottom-navigation
          grow
          v-model="bottomNav"
        >
          <router-link v-for="button in desktopNav" tag="v-btn" :key="button.name" :to="{ name: buildRoute(button.route) }">
            <span>{{ button.title }}</span>
            <v-icon>{{ button.icon }}</v-icon>
          </router-link>
        </v-bottom-navigation>
      </div>
      <transition
        name="fade"
        mode="out-in"
      >
        <keep-alive>
          <router-view />
        </keep-alive>
      </transition>
    </div>
    <v-skeleton-loader
      v-else
      max-width="1200px"
      type="text"
    ></v-skeleton-loader>
  </div>
</template>

<script>
export default {
  middleware: 'auth',
  props: {
    dealerId: { required: false },
    id: { default: '' },
  },
  data: () => ({
    bottomNav: 'FEL',
    bottomNav2: '',
    backURL: 'enterprises',
    firstRowBtns: [
        {
          icon: 'mdi-certificate',
          name: 'FEL',
          title: 'Certificado FEL',
          route: 'enterprise.certificates.fel',
        },
    ],
    secondRowBtns: [
        {
          icon: 'mdi-certificate',
          name: 'PAC',
          title: 'Certificado PAC',
          route: 'enterprise.certificates.pac',
        },
    ],
    loaded: false,
  }),
  computed: {
    enterprise() {
      return this.$store.state.profile.enterprise;
    },
    windowWidth() {
      return this.$store.state.window.width;
    },
    desktopNav() {
      return this.firstRowBtns.concat(this.secondRowBtns);
    },
  },
  async mounted() {
    window.axios.get(`/api/enterprises/${this.enterprise.id}`)
    .then((result) => {
      this.$store.dispatch('profile/setCurrentEnterprise', { enterprise: result.data });
      if (this.enterprise.type === 3) {
        this.firstRowBtns.splice(this.firstRowBtns.findIndex(({ name }) => name === 'PAC'), 1);
      }
      if (this.enterprise.type === 1 || this.enterprise.type === 2) {
        this.secondRowBtns.splice(this.secondRowBtns.findIndex(({ name }) => name === 'FEL'), 1);
      }
      this.loaded = true;
    });
  },
  methods: {
    buildRoute(route) {
      if (this.dealerId) {
        return `dealers.${route}`;
      }
      return route;
    },
  },
};
</script>

<style>
.settings-card .card-body {
  padding: 0;
}
</style>
